import dayjs, { Dayjs } from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { ICandidateWithMessageInfo } from "../App/Typings/MessageText";

dayjs.extend(relativeTime);
dayjs.extend(timezone);
dayjs.extend(utc);

const toUtcEst = (date?: Date | Dayjs, keepLocalTime = false) =>
  dayjs(date).utc(keepLocalTime).tz("America/New_York");

const toNearestFiveMinutes = (date: Dayjs = dayjs().utc().utcOffset(0)) =>
  date.minute(Math.ceil(date.minute() / 5) * 5);

const getDateUtc = (date: Dayjs | string | Date) => dayjs(date).utc();

const getNowUtc = () => dayjs().utc().utcOffset(0);

const candidateInitials = (candidate: Partial<ICandidateWithMessageInfo> | undefined) =>
  candidate ? getFirstChar(candidate.firstName ?? "") + getFirstChar(candidate.lastName ?? "") : "";

const getFirstChar = (value: string) => (value && value.length > 0 ? value[0].toUpperCase() : "");

const toProfileTz = (date: Dayjs | Date | string, timezoneOffset: string) => {
  const offset = parseTimeString(timezoneOffset);

  let tzDate = dayjs(date);

  tzDate = tzDate.add(offset.hours, "hours");
  tzDate = tzDate.add(offset.minutes, "minutes");
  tzDate = tzDate.add(offset.seconds, "seconds");

  return tzDate;
};

const fromProfileTz = (date: Dayjs | Date | string, timezoneOffset: string) => {
  const offset = parseTimeString(timezoneOffset);

  let tzDate = dayjs(date);

  tzDate = tzDate.add(-offset.hours, "hours");
  tzDate = tzDate.add(-offset.minutes, "minutes");
  tzDate = tzDate.add(-offset.seconds, "seconds");

  return tzDate;
};

const parseTimeString = (offset: string) => {
  const timeArray = offset.split(":");

  return {
    hours: parseInt(timeArray[0]),
    minutes: parseInt(timeArray[1]),
    seconds: parseInt(timeArray[2]),
  };
};

export {
  toUtcEst,
  getDateUtc,
  getNowUtc,
  fromProfileTz,
  toNearestFiveMinutes,
  candidateInitials,
  toProfileTz,
};
